<template>
  <div id="app">
    <!-- <header-bar></header-bar> -->
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <!-- <footer-info></footer-info> -->
  </div>
</template>

<script>
import footerInfo from "@/components/common/FooterInfo";
import headerBar from "@/components/common/HeaderBar";
export default {
  name: "App",
  components: {
    footerInfo,
    headerBar,
  },
  mounted: function () {
    console.log(11);
  },
};
</script>

<style>
a {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
  text-decoration: none;
  color: black;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue